import classNames from 'classnames';
import { ReactNode } from 'react';
import CustomTooltip, { ICustomTooltipProps, TOOLTIP_DURATION, TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import './style.scss';

interface IProps {
  isVisible: boolean;
  tooltipOptions?: Partial<ICustomTooltipProps>;
  children?: ReactNode;
}

const IntegrationTooltip = ({ isVisible, tooltipOptions, children }: IProps) => {
  if (!children) return null;

  if (isVisible) {
    return (
      <CustomTooltip
        message="please_disable_posint"
        position={TOOLTIP_POSITION.FIXED}
        duration={TOOLTIP_DURATION.EXTRA_LARGE}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...tooltipOptions}
        wrapperClassName={classNames('integration-tooltip__wrapper', tooltipOptions?.wrapperClassName)}
        contentClassName={classNames('integration-tooltip__content', tooltipOptions?.contentClassName)}
      >
        {children}
      </CustomTooltip>
    );
  }

  return <>{children}</>;
};

export default IntegrationTooltip;
